import { createGlobalStyle } from 'styled-components';
import NotoSansKrDemiLightHestia from '../assets/fonts/NotoSansKR-DemiLight-Hestia.woff';
import NotoSansKrRegularHestia from '../assets/fonts/NotoSansKR-Regular-Hestia.woff';
import NotoSansKrMediumHestia from '../assets/fonts/NotoSansKR-Medium-Hestia.woff';
import NotoSansKrBoldHestia from '../assets/fonts/NotoSansKR-Bold-Hestia.woff';

export const GlobalFont = createGlobalStyle`
  @font-face {
    font-family: 'Noto Sans KR';
    src: local("Noto Sans DemiLight"),
    url(${NotoSansKrDemiLightHestia}) format('woff');
    font-weight: 350;
    font-style: normal;
  }
  @font-face {
    font-family: 'Noto Sans KR';
    src: local("Noto Sans Regular"),
    url(${NotoSansKrRegularHestia}) format('woff');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
      font-family: 'Noto Sans KR';
      src: local("Noto Sans Medium"),
      url(${NotoSansKrMediumHestia}) format('woff');
      font-weight: 500;
      font-style: normal;
  }
  @font-face {
    font-family: 'Noto Sans KR';
    src: local("Noto Sans Bold"),
    url(${NotoSansKrBoldHestia}) format('woff');
    font-weight: 700;
    font-style: normal;
  }
`;
